import { animationData } from './speaker-animation-2x-wide.json'
import { ActiveSpeakerProps, ActiveSpeakerSignal } from './ActiveSpeakerSignal'

export const ActiveSpeakerSignal2xWide: React.FC<Omit<ActiveSpeakerProps, 'animationData'>> = (props) => {
  return <ActiveSpeakerSignal animationData={animationData} {...props} />
}
